import { IDataRequest } from '@vivli/features/data-requests/infrastructure/interface';
import { useDataRequestContext } from '@vivli/features/data-requests/infrastructure/context';
import { useInitializeResearchTeamHook } from '@vivli/features/data-requests/infrastructure/hook';
import { useFormContext } from 'react-hook-form';

export const useDataRequestFormUpdate = () => {
    const formApi = useFormContext();
    const { updateIsSaving } = useDataRequestContext();
    const { transformDataRequest } = useInitializeResearchTeamHook();

    return (updatedDataRequest: IDataRequest) => {
        const initializeDataRequest = transformDataRequest(updatedDataRequest);
        updateIsSaving(false);
        formApi.reset(initializeDataRequest, { keepErrors: true, keepIsValid: true });
    };
};
